import {useMemo} from "react";
import {useTranslations} from "next-intl";
import {IMenuItem} from "@/lib/types/common/IMenuItem";
import {Icon} from "@/app/components/common/Icon";
import {useLobbyCategories} from "@/hooks/use-lobby-categories";
import {categoryIconName, categoryLabelKey} from "@/lib/utils/contants/lobbyCategories";
import {LobbyCategoryTypeEnum} from "@/lib/enums/LobbyCategoryTypeEnum";

// AC-819: the casino section of the side/mobile menus is driven by the same
// backend category list as the lobby, so hiding or reordering a category in
// the backoffice updates the menus too. Known slugs keep their localized
// labels; a new slug falls back to the backend title (rawTitle).
export const useCategoryMenuItems = (): IMenuItem[] => {
    const {categories} = useLobbyCategories();
    const t = useTranslations();

    return useMemo(() => categories.map(category => {
        const labelKey = categoryLabelKey(category.slug);
        const known = t.has(labelKey);
        return {
            icon: <Icon name={categoryIconName(category.slug)}/>,
            title: known ? labelKey : '',
            rawTitle: known ? undefined : category.title,
            href: category.type === LobbyCategoryTypeEnum.PROVIDERS
                ? '/casino/providers'
                : `/casino/categories/${category.slug}`,
        };
    }), [categories, t]);
};
